import React from "react";
import "../styles/style.css";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const Contato = () => {
  return (
    <>
      <Navbar />

      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Fale Connosco</h1>
          <p>
            Estamos disponíveis para esclarecer dúvidas, orçamentos e
            informações sobre mármores e granitos.
          </p>
        </div>
      </section>

      {/* CONTACTOS */}
      <section className="contact-section">
        <div className="contact-grid">

          {/* Endereço */}
          <div className="contact-card">
            <i className="fas fa-map-marker-alt"></i>
            <h3>Morada</h3>
            <p>Rua Comendador Abreu Peixoto nº18</p>
            <span>2580-620 Olhalvo</span>
          </div>

          {/* Email */}
          <div className="contact-card">
            <i className="fas fa-envelope"></i>
            <h3>Email</h3>
            <a href="mailto:Marmoresegranitosgeraldesreis@gmail.com">
              Marmoresegranitosgeraldesreis@gmail.com
            </a>
          </div>

          {/* Telefones */}
          <div className="contact-card">
            <i className="fas fa-phone"></i>
            <h3>Contactos</h3>

            <p>
              <strong>Sérgio Geraldes</strong><br />
              <a href="tel:+351961644428">+351 961 644 428</a>
            </p>

            <p>
              <strong>Rodrigo Reis</strong><br />
              <a href="tel:+351962139829">+351 962 139 829</a>
            </p>

            <p>
              <strong>Francisco Geraldes</strong><br />
              <a href="tel:+351912952090">+351 912 952 090</a>
            </p>
          </div>

        </div>
      </section>

      {/* MAPA */}
      <section className="map-section">
        <h2>Onde Estamos</h2>
        <div className="map-wrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d774.0981530815656!2d-9.06684924508547!3d39.09753075451977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd18d1af35e662f3%3A0xc47e62a3313b3b87!2sN365%2018%2C%20Olhalvo!5e0!3m2!1spt-PT!2spt!4v1740661485534!5m2!1spt-PT!2spt"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contato;
